import { extend } from 'sk-ui/lib/utils/util.js'
import { action } from 'sky-engine/api/index'

import pocProjectDetail from './metaData/pocProjectDetail'
import projectDetailOverview from './metaData/projectDetailOverview'
import ptForm from './metaData/ptForm'
import ptFormForEdit from './metaData/ptFormForEdit'
import reportCreateForm from './metaData/reportCreateForm'

import uploadCollectReport from './metaData/uploadCollectReport'

import { POC_MNG, AREA_INDUSTRY_USER_MNG } from '@/api/apiModules'
import { findNeedNps } from '@/api/nps'
import { updateFlowStatus, copyPocProject } from '@/api/project'
import { getIndustryList, getProjectType, getArea, createQueryCrmOrderInfo } from '@/api/setting'
// import AsyncCrmOrderInfo from '@/components/AsyncCmrOrderInfo'
import collecPreTestingDialog from '@/components/collecPreTestingDialog'
import createTemplateProject from '@/components/CreateTemplateProject'
import FeedbackDialog from '@/components/FeedbackDialog'
import RequestConfirmDialog from '@/components/RequestConfirmDialog'

import lang from '@/lang'
export default {
  EnvCollectReportSuccess({ commit }, params) {
    var reportId = params.response.data.content[0]
    if (this.SkyDeployCollectSoftwareTableBindSuccessCallback) {
      this.SkyDeployCollectSoftwareTableBindSuccessCallback(reportId)
    }
  },
  autoFillIndustry({ commit }, params) {
    let isChannel = this.getters.baseInfo.channel
    if (isChannel) {
      return
    }
    var formData = params.rootView.getFormData()
    var projectArea = formData.projectArea
    var industryId = params.value
    if (!projectArea || !industryId) {
      return
    }
    var request = { industryId: industryId, projectArea: projectArea }
    let data = {
      postsalesLeaderList: [],
      postsalesLeaderLabelList: [],
      extensionIdList: [],
      extensionIdLabelList: []
    }
    action(AREA_INDUSTRY_USER_MNG, 'findAutoFill', request)
      .then(response => {
        data.postsalesLeaderList = response.data.content.postsalesLeaderList
        data.postsalesIdList = response.data.content.postsalesList
        data.extensionIdList = response.data.content.extensionList
        data.postsalesLeaderLabelList = response.data.content.postsalesLeaderLabelList
        data.postsalesIdLabelList = response.data.content.postsalesLabelList
        data.extensionIdLabelList = response.data.content.extensionLabelList
        params.rootView.updateFormData(data)
      })
      .catch(e => {})
  },
  autoFillArea({ commit }, params) {
    let isChannel = this.getters.baseInfo.channel
    if (isChannel) {
      return
    }
    var formData = params.rootView.getFormData()
    var projectArea = params.value
    var industryId = formData.industryId
    if (!projectArea || !industryId) {
      return
    }
    var request = { industryId: formData.industryId, projectArea: params.value }
    let data = {
      postsalesLeaderList: [],
      postsalesLeaderLabelList: [],
      extensionIdList: [],
      extensionIdLabelList: []
    }
    action(AREA_INDUSTRY_USER_MNG, 'findAutoFill', request)
      .then(response => {
        data.postsalesLeaderList = response.data.content.postsalesLeaderList
        data.postsalesIdList = response.data.content.postsalesList
        data.extensionIdList = response.data.content.extensionList
        data.postsalesLeaderLabelList = response.data.content.postsalesLeaderLabelList
        data.postsalesIdLabelList = response.data.content.postsalesLabelList
        data.extensionIdLabelList = response.data.content.extensionLabelList
        params.rootView.updateFormData(data)
      })
      .catch(e => {})
  },
  blurAction({ commit }, params) {
    // var title = '请求CRM信息获取'
    var formData = params.rootView.getFormData()

    let isChannel = this.getters.baseInfo.channel

    if (isChannel) {
      return
    }

    var crmOrderId = formData.crmOrderId
    if (!crmOrderId) {
      return
    }
    createQueryCrmOrderInfo({ crmOrderId: crmOrderId }).then(res => {
      var cmrOrderInfo = res.data.content
      var data = {
        projectName: cmrOrderInfo.opportunityName,
        customer: cmrOrderInfo.finalCustomerName,
        salesIdLabel: {
          id: cmrOrderInfo.salesId,
          label: cmrOrderInfo.ownerName
        },
        presalesIdLabel: {
          id: cmrOrderInfo.presalesId,
          label: cmrOrderInfo.presalesEngineerName
        },
        projectType: cmrOrderInfo.forecastCategoryName
      }
      params.rootView.updateFormData(data)
    })

    // var dialog = this.$root.$dialog({
    //   template: h => {
    //     return (
    //       <sky-async-cmr-order-info
    //         crmOrderId={crmOrderId}
    //         rootView={params.rootView}
    //         onCb={function(data) {
    //           dialog.remove()
    //           if (data.hasCmrOrderInfo) {
    //             var cmrOrderInfo = data.cmrOrderInfo
    //             data = {
    //               projectName: cmrOrderInfo.opportunityName,
    //               customer: cmrOrderInfo.finalCustomerName,
    //               salesIdLabel: {
    //                 id: cmrOrderInfo.salesId,
    //                 label: cmrOrderInfo.ownerName
    //               },
    //               presalesIdLabel: {
    //                 id: cmrOrderInfo.presalesId,
    //                 label: cmrOrderInfo.presalesEngineerName
    //               },
    //               projectType: cmrOrderInfo.forecastCategoryName
    //             }
    //             params.rootView.updateFormData(data)
    //           }
    //         }}
    //       />
    //     )
    //   },
    //   components: {
    //     AsyncCrmOrderInfo
    //   },
    //   props: {
    //     title: title,
    //     width: '30%',
    //     showDefaultFooter: false,
    //     closeOnPressEscape: false
    //   }
    // })
  },
  SetRequestConfirm({ commit }, params) {
    var title = '方案确认（客户反馈售前是否在测试前进行过需求和用例的沟通）'
    var dialog = params.viewController.$dialog({
      template: h => {
        const row = params.row
        return (
          <sky-request-confirm-dialog
            row={row}
            onCb={function() {
              dialog.remove()
              params.viewController.fetch()
            }}
          />
        )
      },
      components: {
        RequestConfirmDialog
      },
      props: {
        title: title,
        width: '30%',
        showDefaultFooter: false,
        closeOnPressEscape: false
      }
    })
  },
  SetPocProjectTemplate({ commit }, params) {
    var title = '设置项目【' + params.row.projectName + '】为模版项目'
    var dialog = params.viewController.$dialog({
      template: h => {
        const row = params.row
        return (
          <sky-create-template-project
            row={row}
            onCb={function() {
              dialog.remove()
              params.viewController.fetch()
            }}
          />
        )
      },
      components: {
        createTemplateProject
      },
      props: {
        title: title,
        width: '45%',
        showDefaultFooter: false, //隐藏确定和取消按钮
        closeOnPressEscape: false
      }
    })

    // SetPocProjectTemplate({
    //   id: params.rowId
    // }).then(res => {
    //   this.dispatch('OpenNotification', { message: '设置模版成功', type: 'success' })
    // })
  },
  CopyPocProject({ commit }, params) {
    copyPocProject({
      id: params.rowId
    }).then(response => {
      setTimeout(() => {
        this.dispatch('OpenConfirm', {
          title: '提示',
          message: '项目【' + params.row.projectName + '】复制成功，现在就进入项目吗？',
          showCancelButton: true,
          showClose: false,
          confirmText: '进入',
          cancelText: '取消',
          option: {
            showIcon: true,
            type: 'info',
            closeOnClickModal: false,
            closeOnPressEscape: false,
            dangerouslyUseHTMLString: true
          }
        })
          .then(btnAction => {
            const props = {
              params: {
                projectId: response.data.content,
                createBytmp: true,
                createByTmpNotBackToFirstStep: true,
                customer: params.row.customer,
                flowStatus: 'MDR_TEST_CASE',
                industryId: params.row.industryId
              }
            }
            const pocProjectDetailCopy = extend(true, {}, pocProjectDetail)
            pocProjectDetailCopy.breadcrumb = {
              title: params.row.projectName,
              action: '',
              class: ''
            }
            this.dispatch('OpenFullDialog', {
              metaData: pocProjectDetailCopy,
              props
            })
          })
          .catch(btnAction => {
            params.viewController.fetch()
          })
      }, 1000)
    })
  },
  ShowFunctionDetail({ commit }, params) {
    params.viewController.$parent.ShowFunctionDetail(params)
  },
  CreateProjectSuccessBack({ commit }, params) {
    const props = {
      params: {
        projectId: params.response.data.content,
        flowStatus: 'MDR_SCENE_RESEARCH',
        industryId: params.requestDatas.industryId
      }
    }
    updateFlowStatus({
      projectId: params.response.data.content,
      flowStatus: 'MDR_SCENE_RESEARCH'
    }).then(res => {})
    const pocProjectDetailCopy = extend(true, {}, pocProjectDetail)
    pocProjectDetailCopy.breadcrumb = {
      title: params.requestDatas.customer,
      action: '',
      class: ''
    }
    this.dispatch('OpenFullDialog', {
      metaData: pocProjectDetailCopy,
      props
    })
  },
  CreatePocProjectDispatch({ commit }, params) {
    let collPreTestingDialog
    const cancelAction = () => {
      collPreTestingDialog.remove()
    }
    const confirmAction = selectedCard => {
      if (selectedCard.type === 'BASE') {
        this.dispatch('CreatePocBaseProject')
      } else {
        this.dispatch('CreatePocDetailProject')
      }
      collPreTestingDialog.remove()
    }
    collPreTestingDialog = this._vm.$dialog({
      template: h => {
        return h('collec-pre-testing-dialog', {
          on: {
            cancel: cancelAction,
            confirm: confirmAction
          }
        })
      },
      components: { collecPreTestingDialog },
      props: {
        width: '30%',
        title: lang.t('pocMng.tips.createPocProject'),
        showDefaultFooter: false
      }
    })
  },
  CreatePocDetailProject({ commit }, params) {
    const _this = this
    const npsParams = { toolId: '6bc818b0-25ee-45dd-b2f5-8d7fb7d6bb3d' }
    findNeedNps(npsParams).then(res => {
      const nps = res.data.content
      if (nps.toolId) {
        var title = '问题反馈与建议'
        var dialog = this.$root.$dialog({
          template: h => {
            const feedback = npsParams
            const isModel = true
            const sourceFrom = 'nps'
            return (
              <sky-feedback-dialog
                feedback={feedback}
                isModel={isModel}
                sourceFrom={sourceFrom}
                onCb={function() {
                  dialog.remove()
                  action(POC_MNG, 'validateLock', {})
                    .then(response => {
                      if (response.data.status === 'SUCCESS') {
                        const props = {
                          params: {
                            projectId: null,
                            flowStatus: 'MDR_PROJECT_INIT'
                          }
                        }
                        const pocProjectDetailCopy = extend(true, {}, pocProjectDetail)
                        pocProjectDetailCopy.breadcrumb = {
                          title: null,
                          action: '',
                          class: ''
                        }
                        _this.dispatch('OpenFullDialog', {
                          metaData: pocProjectDetailCopy,
                          props
                        })
                      }
                    })
                    .catch(e => {
                      throw e
                    })
                }}
              />
            )
          },
          components: {
            FeedbackDialog
          },
          props: {
            title: title,
            width: '45%',
            showClose: false,
            showDefaultFooter: false,
            closeOnPressEscape: false
          }
        })
      } else {
        action(POC_MNG, 'validateLock', {})
          .then(response => {
            if (response.data.status === 'SUCCESS') {
              const props = {
                params: {
                  projectId: null,
                  flowStatus: 'MDR_PROJECT_INIT'
                }
              }
              const pocProjectDetailCopy = extend(true, {}, pocProjectDetail)
              pocProjectDetailCopy.breadcrumb = {
                title: null,
                action: '',
                class: ''
              }
              this.dispatch('OpenFullDialog', {
                metaData: pocProjectDetailCopy,
                props
              })
            }
          })
          .catch(e => {
            throw e
          })
      }
    })
  },
  CreatePocBaseProject({ commit }, params) {
    const ptFormCopy = extend(true, {}, ptForm)

    var props = {
      params: {},
      needFetchFillInfo: false
    }
    this.dispatch('OpenFullDialog', { metaData: ptFormCopy, props, clone: false })
  },
  EditProTestProjectBaseInfo({ commit }, params) {
    const ptFormForEditCopy = extend(true, {}, ptFormForEdit)
    const props = {
      title: 'pocMng.editProject',
      params: {
        id: params.rowIds[0]
      },
      needFetchFillInfo: true
    }
    this.dispatch('OpenFullDialog', { metaData: ptFormForEditCopy, props, clone: false })
  },
  CreateTemplateProjectSuccess({ commit }, params) {
    this.dispatch('OpenConfirm', {
      title: '提示',
      message: '项目创建成功，直接生成测试方案还是继续完善项目其它信息？',
      showCancelButton: true,
      showClose: false,
      confirmText: '直接生成测试方案',
      cancelText: '继续完善项目信息',
      option: {
        showIcon: true,
        type: 'info',
        closeOnClickModal: false,
        closeOnPressEscape: false,
        dangerouslyUseHTMLString: true
      }
    })
      .then(btnAction => {
        const props = {
          params: {
            projectId: params.response.data.content,
            createBytmp: true,
            createByTmpNotBackToFirstStep: true,
            customer: params.requestDatas.customer,
            flowStatus: 'CREATE_ORDER',
            industryId: params.requestDatas.industryId
          }
        }
        const pocProjectDetailCopy = extend(true, {}, pocProjectDetail)
        pocProjectDetailCopy.breadcrumb = {
          title: params.requestDatas.projectName,
          action: '',
          class: ''
        }
        this.dispatch('OpenFullDialog', {
          metaData: pocProjectDetailCopy,
          props
        })
        updateFlowStatus({
          projectId: params.response.data.content,
          flowStatus: 'CREATE_ORDER'
        }).then(res => {})
      })
      .catch(btnAction => {
        const props = {
          params: {
            projectId: params.response.data.content,
            createBytmp: true,
            createByTmpNotBackToFirstStep: true,
            customer: params.requestDatas.customer,
            flowStatus: 'MDR_TEST_CASE',
            industryId: params.requestDatas.industryId
          }
        }
        const pocProjectDetailCopy = extend(true, {}, pocProjectDetail)
        pocProjectDetailCopy.breadcrumb = {
          title: params.requestDatas.projectName,
          action: '',
          class: ''
        }
        this.dispatch('OpenFullDialog', {
          metaData: pocProjectDetailCopy,
          props
        })
      })
  },
  ShowPocProjectDetail({ commit }, params) {
    const req = {
      projectId: params.row.id
    }

    action(POC_MNG, 'applyLock', req)
      .then(response => {
        const props = {
          params: {
            projectId: params.row.id,
            createBytmp: false,
            customer: params.row.customer,
            projectCode: params.row.projectCode,
            flowStatus: params.row.flowStatus,
            industryCode: params.row.industryCode,
            industryId: params.row.industryId
          }
        }
        const pocProjectDetailCopy = extend(true, {}, pocProjectDetail)
        pocProjectDetailCopy.breadcrumb = {
          title: params.row.name,
          action: '',
          class: ''
        }
        this.dispatch('OpenFullDialog', {
          metaData: pocProjectDetailCopy,
          props
        })
      })
      .catch(e => {
        throw e
      })
  },
  ShowProjectOverview({ commit }, params) {
    const props = {
      params: {
        id: params.id,
        customer: params.customer,
        projectCode: params.projectCode,
        flowStatus: params.flowStatus
      }
    }
    this.dispatch('OpenDrawerDetailRelation', {
      metaData: projectDetailOverview,
      props,
      drawerProps: {
        class: 'wsp-case-relation-drawer-fl-65'
      }
    })
  },
  ShowProjectOverviewForTableList({ commit }, params) {
    const props = {
      params: {
        id: params.id,
        customer: params.customer,
        projectCode: params.projectCode,
        flowStatus: params.flowStatus
      }
    }
    this.dispatch('OpenDetailDialog', {
      metaData: projectDetailOverview,
      props
    })
  },
  ShowCollectInfo({ commit }, props) {
    import('./metaData/relationCollectInfo').then(metaData => {
      this.dispatch('OpenRelationDialog', { metaData, props })
    })
  },
  PmCollectReportUpload({ commit }, params) {
    const uploadCollectReportCopy = extend(true, {}, uploadCollectReport)
    var props = {
      params: {}
    }
    this.dispatch('OpenFullDialog', { metaData: uploadCollectReportCopy, props, clone: false })
  },
  ReportCreate({ commit }, params) {
    this.dispatch('OpenFullDialog', {
      metaData: reportCreateForm
    })
  },
  AfterReportCreate({ commit }, params) {
    params.formController.ok().then(response => {
      const collectView = params.formController.views.extraParams?.collectView
      if (collectView.changeScene.collectReportDTOList?.length < 5 || !collectView.changeScene?.collectReportDTOList) {
        const data = collectView.changeScene
        !data.collectReportDTOList && (data.collectReportDTOList = [])
        if (response.data.content?.length) {
          for (const item of response.data.content) {
            if (data.collectReportDTOList.length < 5) {
              data.collectReportDTOList.push(item)
            } else {
              this.dispatch('OpenNotification', {
                message: '一个场景最多只支持绑定5个报告，超出数量限制的报告未自动绑定，请按需重选',
                type: 'error'
              })
              break
            }
          }
          collectView.changeSceneRel(data)
        }
      }
    })
  },
  CreatePocProjectFromTemplateForHelp({ commit }, params) {
    action(POC_MNG, 'detail', {
      id: params.id
    }).then(result => {
      result.data.content.projectName = null
      result.data.content.customer = null
      result.data.content.salesIdLabel = null
      result.data.content.presalesIdLabel = null
      result.data.content.postsalesIdLabelList = null
      result.data.content.extensionIdLabelList = null
      result.data.content.startTime = null
      result.data.content.projectCycle = null
      var value_data = result.data.content
      value_data.templateProjectLabel = {
        id: params.id,
        label: params.label
      }
      value_data.sourceFrom = 'HELP'

      var request = { industryId: result.data.content.industryId, projectArea: result.data.content.projectArea }
      if (result.data.content.projectArea) {
        action(AREA_INDUSTRY_USER_MNG, 'findAutoFill', request).then(response => {
          value_data.postsalesLeaderList = response.data.content.postsalesLeaderList
          value_data.postsalesIdList = response.data.content.postsalesList
          value_data.extensionIdList = response.data.content.extensionList
          value_data.postsalesLeaderLabelList = response.data.content.postsalesLeaderLabelList
          value_data.postsalesIdLabelList = response.data.content.postsalesLabelList
          value_data.extensionIdLabelList = response.data.content.extensionLabelList
          this.dispatch('CreatePocProjectFromTemplate', value_data)
        })
      } else {
        delete value_data.projectArea
        this.dispatch('CreatePocProjectFromTemplate', value_data)
      }
    })
  },
  CreatePocProjectFromTemplate({ commit }, params) {
    var initProps = {
      params: {
        projectId: null,
        flowStatus: 'MDR_PROJECT_INIT'
      }
    }

    var newParams = {}

    if (params?.sourceFrom === 'HELP') {
      const new_data = Object.assign({}, params, initProps)
      newParams = new_data
    } else {
      newParams = initProps
    }
    const props = newParams

    const ptFormCopy = extend(true, {}, ptForm)
    ptFormCopy.breadcrumb = {
      title: null,
      action: '',
      class: ''
    }
    ptFormCopy.callBackAction = 'CreateTemplateProjectSuccess'
    ptFormCopy.view.content.unshift({
      $id: 'templateProjectLabel',
      $type: 'sky-relation-option',
      label: '项目模版',
      $el: { disabled: false, multiple: false },
      actions: {
        nativeOn: {
          click: 'UmRelationTemplateProject'
        },
        on: {
          updateValue: 'ProjectTemplateFillBack'
        }
      },
      rules: [{ notEmpty: { message: '模版项目不能为空' } }]
    })

    //filter channel
    let isChannel = this.getters.baseInfo.channel
    if (isChannel) {
      let idIndex = ptFormCopy.view.content.findIndex(item => {
        return item.$id === 'crmOrderId'
      })
      if (idIndex > 0) {
        ptFormCopy.view.content.splice(idIndex, 1)
      }
      idIndex = ptFormCopy.view.content.findIndex(item => {
        return item.$id === 'projectArea'
      })
      if (idIndex > 0) {
        ptFormCopy.view.content.splice(idIndex, 1)
      }
      idIndex = ptFormCopy.view.content.findIndex(item => {
        return item.$id === 'postsalesLeaderLabelList'
      })
      if (idIndex > 0) {
        ptFormCopy.view.content.splice(idIndex, 1)
      }
      idIndex = ptFormCopy.view.content.findIndex(item => {
        return item.$id === 'extensionIdLabelList'
      })
      if (idIndex > 0) {
        ptFormCopy.view.content.splice(idIndex, 1)
      }
    }

    getIndustryList({}).then(res => {
      var changeList = []
      for (const iterator of res.data.content.itemArr) {
        changeList.push({
          id: iterator.id,
          value: iterator.id,
          label: iterator.industryName
        })
      }
      ptFormCopy.view.content[1].$options = changeList
      getProjectType().then(res => {
        var list = res.data.content.itemArr
        var changeList = []
        for (const iterator of list) {
          changeList.push({
            id: iterator.id,
            value: iterator.id,
            code: iterator.label,
            label: iterator.label
          })
        }
        let idIndex = ptFormCopy.view.content.findIndex(item => {
          return item.$id === 'projectType'
        })
        ptFormCopy.view.content[idIndex].$options = changeList

        const _this = this
        const npsParams = { toolId: '6bc818b0-25ee-45dd-b2f5-8d7fb7d6bb3d' }
        if (params?.sourceFrom === 'HELP') {
          // 处理逻辑
          getArea().then(res => {
            var list_area = res.data.content.itemArr
            var areaList = []
            for (const iterator of list_area) {
              areaList.push({
                id: iterator.id,
                label: iterator.label
              })
            }

            var area_item = {
              $id: 'projectArea',
              $type: 'select',
              label: 'pocMng.projectArea',
              $el: {
                clearable: true
              },
              $options: areaList,
              rules: [{ notEmpty: { message: 'pocMng.projectAreaEmpty' } }],
              actions: {
                on: {
                  change: 'autoFillArea'
                }
              }
            }
            ptFormCopy.view.content.splice(2, 1, area_item)

            findNeedNps(npsParams).then(res => {
              const nps = res.data.content
              if (nps.toolId) {
                var title = '问题反馈与建议'
                var dialog = this.$root.$dialog({
                  template: h => {
                    const feedback = npsParams
                    const isModel = true
                    const sourceFrom = 'nps'
                    return (
                      <sky-feedback-dialog
                        feedback={feedback}
                        isModel={isModel}
                        sourceFrom={sourceFrom}
                        onCb={function() {
                          dialog.remove()
                          _this.dispatch('OpenFullDialog', {
                            metaData: ptFormCopy,
                            props
                          })
                        }}
                      />
                    )
                  },
                  components: {
                    FeedbackDialog
                  },
                  props: {
                    title: title,
                    width: '45%',
                    showClose: false,
                    showDefaultFooter: false,
                    closeOnPressEscape: false
                  }
                })
              } else {
                _this.dispatch('OpenFullDialog', {
                  metaData: ptFormCopy,
                  props
                })
              }
            })
          })
        } else {
          findNeedNps(npsParams).then(res => {
            const nps = res.data.content
            if (nps.toolId) {
              var title = '问题反馈与建议'
              var dialog = _this.$root.$dialog({
                template: h => {
                  const feedback = npsParams
                  const isModel = true
                  const sourceFrom = 'nps'
                  return (
                    <sky-feedback-dialog
                      feedback={feedback}
                      isModel={isModel}
                      sourceFrom={sourceFrom}
                      onCb={function() {
                        dialog.remove()
                        _this.dispatch('OpenFullDialog', {
                          metaData: ptFormCopy,
                          props
                        })
                      }}
                    />
                  )
                },
                components: {
                  FeedbackDialog
                },
                props: {
                  title: title,
                  width: '45%',
                  showClose: false,
                  showDefaultFooter: false,
                  closeOnPressEscape: false
                }
              })
            } else {
              _this.dispatch('OpenFullDialog', {
                metaData: ptFormCopy,
                props
              })
            }
          })
        }
      })
    })
  },
  UmRelationTemplateProject({ commit }, props) {
    import('./metaData/pt').then(metaData => {
      const metaDataCopy = extend(true, {}, metaData.default)
      props.params = {
        isTemplate: true,
        flowStatus: 'MDR_TEST_CASE'
      }
      metaDataCopy.listUrl = 'projectInfo/template/list'
      metaDataCopy.toolbar = {
        searchWidth: 360,
        searchPlaceholder: 'pocMng.searchPlaceholder',
        searchFieldNameArr: ['customer', 'projectCode', 'createUserName']
      }
      metaDataCopy.view.columns.splice(0, 1, {
        props: {
          label: 'pocMng.projectName',
          prop: 'projectName',
          sortField: 'projectName',
          'min-width': 260
        },
        dataType: 'custom',
        action: '',
        custom: function(row, h, value, e) {
          return (
            <div
              class="sk-link--normal"
              on-click={$event => {
                this.$store.dispatch('ShowProjectOverview', row)
              }}
            >
              {value}
            </div>
          )
        }
      })
      metaDataCopy.view.columns.unshift({
        props: {
          type: 'radio',
          width: 55
        }
      })
      metaDataCopy.view.menus = [
        {
          icon: 'el-icon-delete',
          label: 'delete',
          command: 'UmDeleteUser',
          name: 'umDeleteUser',
          confirm: {
            grade: 0,
            msg: 'pocMng.tips.deleteTemplateProject'
          }
        }
      ]
      this.dispatch('OpenRelationDialog', { metaData: metaDataCopy, props, clone: false })
    })
  },
  ProjectTemplateFillBack({ commit }, { rootView, value }) {
    action(POC_MNG, 'detail', {
      id: value.row.id
    }).then(result => {
      result.data.content.projectName = null
      result.data.content.customer = null
      result.data.content.salesIdLabel = null
      result.data.content.presalesIdLabel = null
      result.data.content.postsalesIdLabelList = null
      result.data.content.extensionIdLabelList = null
      result.data.content.startTime = null
      result.data.content.projectCycle = null

      if (result.data.content.projectArea) {
        var request = { industryId: result.data.content.industryId, projectArea: result.data.content.projectArea }

        action(AREA_INDUSTRY_USER_MNG, 'findAutoFill', request)
          .then(response => {
            result.data.content.postsalesLeaderList = response.data.content.postsalesLeaderList
            result.data.content.postsalesIdList = response.data.content.postsalesList
            result.data.content.extensionIdList = response.data.content.extensionList
            result.data.content.postsalesLeaderLabelList = response.data.content.postsalesLeaderLabelList
            result.data.content.postsalesIdLabelList = response.data.content.postsalesLabelList
            result.data.content.extensionIdLabelList = response.data.content.extensionLabelList
            rootView.updateFormData(result.data.content)
          })
          .catch(e => {})
      } else {
        result.data.content.postsalesLeaderList = []
        result.data.content.postsalesIdLabelList = []
        result.data.content.postsalesIdList = []
        result.data.content.postsalesLeaderLabelList = []
        result.data.content.extensionIdList = []
        result.data.content.extensionIdLabelList = []

        rootView.updateFormData(result.data.content)
      }
    })
  }
}
